import { render } from "./tabsIcon.vue?vue&type=template&id=1fc29b19"
import script from "./tabsIcon.vue?vue&type=script&lang=js"
export * from "./tabsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__